import { render, staticRenderFns } from "./MemberAreaModuleDetail.vue?vue&type=template&id=f0f72c5c&scoped=true&"
import script from "./MemberAreaModuleDetail.vue?vue&type=script&lang=js&"
export * from "./MemberAreaModuleDetail.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaModuleDetail.vue?vue&type=style&index=0&id=f0f72c5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f72c5c",
  null
  
)

export default component.exports